import { render, staticRenderFns } from "./AISourceTag.vue?vue&type=template&id=64001242&scoped=true"
import script from "./AISourceTag.vue?vue&type=script&lang=js"
export * from "./AISourceTag.vue?vue&type=script&lang=js"
import style0 from "./AISourceTag.vue?vue&type=style&index=0&id=64001242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64001242",
  null
  
)

export default component.exports